<template>
  <section>
    <div class="message disp-scroll">
      <b-tabs style="background: white;">
        <!-- 基本設定タブ -->
        <b-tab-item class="tab-box disp-scroll" label="基本設定">
          <!-- 日程自動調整タイトル -->
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p style="text-align: left;">
                <b>タイトル</b>
                <br>
                <span class="item-title">
                  ※引用リストのパラメータも有効です。
                </span>
              </p>
            </div>
            <div class="tab-box-right">
              <b-input
                style="width: 100%;"
                placeholder="タイトルを入力"
                v-model="calParameter.title"
                max-length="100"
                :disabled="scenarioEdit.is_confirm"
              />
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- 予定時間 -->
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p><b>予定時間</b></p>
            </div>
            <div class="tab-box-right">
              <p style="display: flex; align-items: center;">
                <b-numberinput
                  style="width: 100px;"
                  size="is-small"
                  :editable="false"
                  step="1"
                  min="0"
                  max="23"
                  v-model="calParameter.mtg_time_hour"
                  controls-position="compact"
                  :disabled="scenarioEdit.is_confirm"
                />
                <span style="margin-left: 4px;">時間</span>
              </p>
              <p style="display: flex; align-items: center; margin-left: 16px;">
                <b-numberinput
                  style="width: 100px;"
                  size="is-small"
                  :editable="false"
                  step="15"
                  min="0"
                  max="45"
                  v-model="calParameter.mtg_time_minute"
                  controls-position="compact"
                  :disabled="scenarioEdit.is_confirm"
                />
                <span style="margin-left: 4px;">分</span>
              </p>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- 日程取得方法 -->
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p style="text-align: left;">
                <b>日程取得方法</b>
              <br>
                <span class="item-title">
                  日程の「仮枠」から取得の場合は、
                  カレンダーの予定に「仮枠」と記載されているところが
                  空き時間として表示されます。
                </span>
              </p>
            </div>
            <div class="tab-box-right">
              <p style="text-align: left;">
                <select class="select is-small" placeholder="方法を選択" v-model="calParameter.date_method" :disabled="scenarioEdit.is_confirm">
                  <option
                    v-for="(m, idx) in ['日程の空いているところから取得', '日程の「仮枠」から取得']"
                    :key="idx"
                    :value="idx">
                    {{m}}
                  </option>
                </select>
                <br>
                <br>
                <b-checkbox v-model="calParameter.is_all_day" :disabled="scenarioEdit.is_confirm">
                  終日予定がある日は日程調整不可とする
                </b-checkbox>
                <br>
                <b-checkbox v-model="calParameter.is_hidden_calendar" :disabled="scenarioEdit.is_confirm">
                  候補日時のみが表示され、カレンダーは非表示となります
                </b-checkbox>
              </p>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- 仮枠重複許可数 -->
          <!-- 日程調整方法が仮枠の場合は表示 -->
          <template v-if="calParameter.date_method === 1">
            <div class="tab-box-form">
              <div class="tab-box-left">
                <p style="text-align: left;">
                  <b>仮枠の予定重複許可数</b>
                  <br>
                  <span class="item-title">
                    ひとつの仮枠に登録可能な予定数を登録します。<br/>
                    「0」を指定した場合は制限なしとなります。
                  </span>
                </p>
              </div>
              <div class="tab-box-right">
                <p style="display: flex; align-items: center;">
                  <b-numberinput
                    size="is-small"
                    style="width: 100px;"
                    v-model="calParameter.duplicate_num"
                    :editable="false"
                    min="0"
                    max="50"
                    controls-position="compact"
                    :disabled="scenarioEdit.is_confirm"
                  />
                </p>
              </div>
            </div>
            <div class="dot-line"></div>
          </template>
          <!-- 参加者または必須参加者 -->
          <div class="tab-box-form">
            <div class="tab-box-left" style="flex-wrap: wrap;">
              <template v-if="calParameter.date_method === 0">
                <!-- 日程調整方法が空き日程の場合は表示 -->
                <p style="text-align: left;" v-if="calParameter.is_AND">
                  <b>必須参加者</b>
                  <br>
                  <span class="item-title">最低1人以上お選びください。</span><br>
                  <span class="item-title">選択したメンバーは必ず参加します。</span>
                </p>
                <p style="text-align: left;" v-if="!calParameter.is_AND">
                  <b>参加者</b>
                  <br>
                  <span class="item-title">選択した中から1人が選ばれます。</span><br>
                  <span class="item-title">選ばれた1人は必ず参加します。</span>
                </p>
                <b-switch style="width: 100%;" size="is-small" v-model="calParameter.is_AND" :disabled="scenarioEdit.is_confirm">切替</b-switch>
              </template>
              <template v-else>
                <!-- 日程調整方法が仮枠の場合は表示 -->
                <p style="text-align: left;">
                  <b>参加者</b>
                  <br>
                  <span class="item-title">選択した中から1人が選ばれます。</span><br>
                  <span class="item-title">選ばれた1人は必ず参加します。</span>
                </p>
              </template>
            </div>
            <div class="tab-box-right" style="flex-wrap: wrap;">
              <SelectMemberTable
                :isCalendar="true"
                :users = users
                :parameterHash="calParameter.user_hash"
                :calParameter="calParameter"
                :selfUser="user"
                :calendarSettings="calendarSettings"
                :isSync="true"
                :isConfirm="scenarioEdit.is_confirm"
                :usersStatusAPI="usersStatusAPI"
                @changeShowEventSelfSelectMember="addSelfUserHash"
                @createCalendarSettingsSelectMember="addUserHash"
                style="height: 250px;"/>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- 任意参加者 -->
          <!-- 日程調整方法が仮枠の場合は非表示 -->
          <template v-if="calParameter.date_method === 0">
            <div class="tab-box-form">
              <div class="tab-box-left" style="flex-wrap: wrap;">
                <p style="text-align: left;">
                  <b>任意参加者</b>
                  <br>
                  <span class="item-title">選択した中から1人が選ばれます。</span><br>
                  <span class="item-title">選ばれた1人が参加できる場合は、参加します。</span>
                </p>
              </div>
              <div class="tab-box-right" style="flex-wrap: wrap;">
                <SelectMemberTable
                  :isCalendar="true"
                  :users = users
                  :parameterHash="calParameter.user_hash_sub"
                  :calParameter="calParameter"
                  :selfUser="user"
                  :calendarSettings="calendarSettings"
                  :isSync="true"
                  :isConfirm="scenarioEdit.is_confirm"
                  :usersStatusAPI="usersStatusAPI"
                  @changeShowEventSelfSelectMember="addSelfUserHashSub"
                  @createCalendarSettingsSelectMember="addUserHashSub"
                  style="height: 250px;"/>
              </div>
            </div>
            <div class="dot-line"></div>
          </template>
          <!-- 共有者 -->
          <div class="tab-box-form">
            <div class="tab-box-left" style="flex-wrap: wrap;">
              <p style="text-align: left;">
                <b>共有者</b>
                <br>
                <span class="item-title">
                  選択されたメンバーは参加の可否にかかわらず、予定が共有されます。
                </span>
              </p>
            </div>
            <div class="tab-box-right" style="flex-wrap: wrap;">
              <SelectMemberTable
                :isCalendar="true"
                :users = users
                :parameterHash="calParameter.user_hash_share"
                :calParameter="calParameter"
                :selfUser="user"
                :calendarSettings="calendarSettings"
                :isSync="true"
                :isConfirm="scenarioEdit.is_confirm"
                :usersStatusAPI="usersStatusAPI"
                @changeShowEventSelfSelectMember="addSelfUserHashShare"
                @createCalendarSettingsSelectMember="addUserHashShare"
                style="height: 250px;"/>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- 休日設定 -->
          <div class="tab-box-form">
            <div class="tab-box-left" style="flex-wrap: wrap;">
              <p style="text-align: left;">
                <b><!--設定しない曜日-->休日</b>
                <br>
                <span class="item-title">
                  選択された曜日は予定調整可能日から外されます。
                </span>
              </p>
            </div>
            <div class="tab-box-right">
              <b-checkbox v-for="(ch, idx) in weekdayList" :key="idx" v-model="calParameter.holiday_list"
                :native-value="idx"
                :disabled="scenarioEdit.is_confirm">
                {{ch}}
              </b-checkbox>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- 祝日設定 -->
          <div class="tab-box-form">
            <div class="tab-box-left" style="flex-wrap: wrap;">
              <p style="text-align: left;">
                <b><!--設定しない曜日-->祝日</b>
                <br>
                <span class="item-title">
                  選択すると祝日は予定調整可能日から外されます。
                </span>
              </p>
            </div>
            <div class="tab-box-right">
              <b-switch style="width: 100%;" size="is-small" v-model="calParameter.public_holiday" :disabled="scenarioEdit.is_confirm">
              </b-switch>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- 調整可能時間帯 -->
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p><b>調整可能時間帯</b></p>
            </div>
            <div class="tab-box-right">
              <b-timepicker v-model="start" size="is-small" inline :disabled="scenarioEdit.is_confirm"></b-timepicker>
              <p style="font-size: 24px;margin-left:10px;margin-right:10px;"><b>-</b></p>
              <b-timepicker v-model="end" size="is-small" inline :disabled="scenarioEdit.is_confirm"></b-timepicker>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- 動画面接リンク挿入設定 -->
          <div class="tab-box-form">
            <div class="tab-box-left" style="flex-wrap: wrap;">
              <p style="text-align: left;">
                <b>動画面接リンク</b>
                <br>
                <span class="item-title">
                  予定のメモ欄に動画面接のリンクを追記します。
                </span>
                <span class="item-title">
                  ※「リンク追記する」にした場合、メール送付パーツで__video__と入力すると動画面接リンクに変換できます。
                </span>
              </p>
            </div>
            <div class="tab-box-right" style="flex-wrap: wrap;">
              <b-switch style="width: 100%;" size="is-small" v-model="calParameter.video_interview_memo" :disabled="scenarioEdit.is_confirm">
                リンクを追記{{calParameter.video_interview_memo ? 'する' : 'しない'}}
              </b-switch>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- メモ -->
          <div class="tab-box-form">
            <div class="tab-box-left" style="flex-wrap: wrap;">
              <p><b>メモ</b></p>
              <br>
              <span class="item-title" style="text-align: left;">
                日程調整をした日の予定に入れるメモ欄です。引用リストのパラメータも有効です。
              </span>
            </div>
            <div class="tab-box-right">
              <textarea class="input textarea disp-scroll" v-model="calParameter.memo" maxlength="200" :disabled="scenarioEdit.is_confirm"></textarea>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- 日程調整開始日 -->
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p style="text-align: left;">
                <b>日程調整開始日</b>
                <br>
                <span class="item-title">
                  現在から何日後か入力します
                </span>
              </p>
            </div>
            <div class="tab-box-right">
              <p style="display: flex; align-items: center;">
                <b-numberinput
                  size="is-small"
                  style="width: 100px;"
                  v-model="calParameter.after"
                  :editable="false"
                  min="0"
                  max="10"
                  controls-position="compact"
                  :disabled="scenarioEdit.is_confirm"
                />
                <span style="margin-left: 4px;">
                  日後
                </span>
              </p>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- 日程調整期間 -->
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p style="text-align: left;">
                <b>日程調整期間</b>
                <br>
                <span class="item-title">
                  現在から何ヶ月後まで調整可能か入力します
                </span>
              </p>
            </div>
            <div class="tab-box-right">
              <p style="display: flex; align-items: center;">
                <b-numberinput
                  size="is-small"
                  style="width: 100px;"
                  v-model="calParameter.period"
                  :editable="false"
                  min="0"
                step="0.5"
                  controls-position="compact"
                  :disabled="scenarioEdit.is_confirm"
                />
                <span style="margin-left: 4px;">
                {{
                  calParameter.period === 0 ? '無期限' :
                  calParameter.period === 0.5 ? '２週間後まで' :
                  calParameter.period % 1 === 0.5 ? Math.floor(calParameter.period) + 'ヶ月+２週間後まで' :
                  calParameter.period + 'ヶ月後まで'
                }}
                </span>
              </p>
            </div>
          </div>
        <div class="dot-line"></div>
        <!-- 絶対日付制限 -->
        <div class="tab-box-form">
          <div class="tab-box-left">
            <p style="text-align: left;">
              <b>日付制限</b>
              <br>
              <span style="color: #666; font-size: 12px;">
                特定の日付以降を選択不可にします
              </span>
            </p>
          </div>
          <div class="tab-box-right">
            <b-field grouped>
              <b-switch v-model="calParameter.useAbsoluteLimit" :disabled="scenarioEdit.is_confirm">
                日付制限を使用
              </b-switch>
            </b-field>
            <b-field v-if="calParameter.useAbsoluteLimit">
              <b-datepicker
                v-model="calParameter.absoluteMaxDateObj"
                @input="updateAbsoluteMaxDate"
                placeholder="制限日を選択"
                :min-date="new Date()"
                locale="ja-JP"
                :day-names="['日', '月', '火', '水', '木', '金', '土']"
                :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                :disabled="scenarioEdit.is_confirm"
              />
            </b-field>
            <p v-if="calParameter.useAbsoluteLimit && calParameter.absoluteMaxDate" style="color: #666; font-size: 12px; margin-top: 8px;">
              {{ calParameter.absoluteMaxDate }}以降は選択不可
            </p>
          </div>
        </div>
          <div class="dot-line"></div>
          <!-- 日程公開設定 -->
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p style="text-align: left;">
                <b>日程の公開・非公開</b>
                <br>
                <span class="item-title">
                  公開にするか非公開にするか選択できます。
                </span>
              </p>
            </div>
            <div class="tab-box-right">
              <select class="select is-small" v-model="calParameter.is_private" :disabled="scenarioEdit.is_confirm">
                <option
                  v-for="(m, idx) in [false, true]"
                  :key="idx"
                  :value="m">
                  {{!m ? '公開' : '非公開'}}
                </option>
              </select>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- 予定間バッファ時間設定 -->
          <!-- 日程調整方法が仮枠の場合は非表示 -->
          <template v-if="calParameter.date_method === 0">
            <div class="tab-box-form">
              <div class="tab-box-left">
                <p style="text-align: left;">
                  <b>バッファ</b>
                  <br>
                  <span class="item-title">
                    予定間の空き時間を入力します
                  </span>
                </p>
              </div>
              <div class="tab-box-right">
                <p style="display: flex; align-items: center;">
                  <b-numberinput
                    size="is-small"
                    style="width: 100px;"
                    step="15"
                    :editable="false"
                    v-model="calParameter.interval"
                    min="0"
                    max="120"
                    controls-position="compact"
                    :disabled="scenarioEdit.is_confirm"
                  />
                  <span style="margin-left: 4px;">分</span>
                </p>
              </div>
            </div>
            <div class="dot-line"></div>
          </template>
          <!-- 予定取得不可時メッセージ設定 -->
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p style="text-align: left;">
                <b>空き予定取得不可</b>
                <br>
                <span class="item-title">
                  直近30日以内に3日以上の予定調整可能日がない場合にメッセージとして表示します。引用リストのパラメータは利用できません。
                </span>
              </p>
            </div>
            <div class="tab-box-right">
              <textarea class="input textarea disp-scroll" v-model="calParameter.no_candidate" maxlength="200" :disabled="scenarioEdit.is_confirm"></textarea>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- 希望日程入力設定 -->
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p style="text-align: left;">
                <b>
                  選択肢「希望する日程がない」 を
                  <span v-if="calParameter.is_nothing_target_date">表示</span>
                  <span v-else>非表示</span>
                </b>
                <br>
                <span class="item-title">
                  選択すると分岐を行うことができ、ユーザーに手動で日程や要望を自由入力させることができます。
                </span>
                <br>
              </p>
            </div>
            <div class="tab-box-right">
              <!-- 出力設定されている際は分岐できないように制御追加（3/30） -->
              <b-switch
                style="width: 100%;"
                size="is-small"
                v-model="calParameter.is_nothing_target_date"
                :disabled="scenarioEdit.is_confirm || scenarioEdit.output_flg">
              </b-switch>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- 予定設定間隔設定(30分おきか、1時間おきか) -->
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p style="text-align: left;">
                <b>予定の提案間隔設定</b>
                <br>
                <span class="item-title">
                  提案する予定の開始時間が00分か30分か設定ができます。
                </span>
              </p>
            </div>
            <div class="tab-box-right">
              <b-switch
                style="width: 100%;"
                size="is-small"
                v-model="calParameter.divide"
                :true-value="0"
                :false-value="30"
                :disabled="scenarioEdit.is_confirm"
              >
                {{calParameter.divide === 0 ? '1時間間隔' : '30分間隔'}}
              </b-switch>
            </div>
          </div>
        </b-tab-item>
        <!-- リマインダー設定タブ -->
        <b-tab-item label="リマインダー設定（Email）" class="tab-box disp-scroll">
          <!-- リマインダー通知設定 -->
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p style="text-align: left;">
                <b>リマインダー通知</b>
                <br>
                <span class="item-title">
                  ONにすると設定したメールが届きます
                </span>
              </p>
            </div>
            <div class="tab-box-right">
              <b-switch style="width: 100%;" v-model="calParameter.reminder_flg" :disabled="scenarioEdit.is_confirm">切替</b-switch>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- リマインダー通知日設定 -->
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p style="text-align: left;">
                <b>リマインダー通知日</b>
                <br>
                <span class="item-title">
                  日程調整をした日の何日前に送るか設定します
                </span>
              </p>
            </div>
            <div class="tab-box-right">
              <p style="display: flex; align-items: center;">
                <b-numberinput
                  v-model="calParameter.reminder_day"
                  :editable="false"
                  min="0"
                  max="10"
                  style="width: 100px;"
                  size="is-small"
                  controls-position="compact"
                  :disabled="!calParameter.reminder_flg || scenarioEdit.is_confirm"
                />
                <span style="margin-left: 4px;">日前</span>
              </p>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- 直前リマインダー通知設定 -->
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p style="text-align: left;">
                <b>直前リマインダー通知</b>
                <br>
                <span class="item-title">
                  ONにすると登録された予定時間の直前に再度メールが届きます<br/>
                  ※30分〜120分前の間で設定可能です
                </span>
              </p>
            </div>
            <div class="tab-box-right">
              <b-switch
                style="width: 40%;"
                v-model="calParameter.reminder_before_flg"
                :disabled="!calParameter.reminder_flg || scenarioEdit.is_confirm"
              >
                切替
              </b-switch>
              <p style="display: flex; align-items: center;">
                <b-numberinput
                  style="width: 100px;"
                  size="is-small"
                  :editable="false"
                  step="10"
                  min="30"
                  max="120"
                  v-model="calParameter.reminder_before_minute"
                  controls-position="compact"
                  :disabled="!calParameter.reminder_flg||!calParameter.reminder_before_flg || scenarioEdit.is_confirm"
                />
                <span style="margin-left: 4px;">分前</span>
              </p>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- メンバーへのリマインダー通知送付設定 -->
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p style="text-align: left;">
                <b>メンバーにも送付</b>
                <br>
                <span class="item-title">
                  ONにすると基本設定で選択したメンバーおよびユーザーにもメールが届きます
                </span>
              </p>
            </div>
            <div class="tab-box-right">
              <b-switch
                style="width: 100%;"
                v-model="calParameter.reminder_member_flg"
                :disabled="!calParameter.reminder_flg || scenarioEdit.is_confirm"
              >
                切替
              </b-switch>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- 動画面接リンク挿入設定 -->
          <div class="tab-box-form">
            <div class="tab-box-left" style="flex-wrap: wrap;">
              <p style="text-align: left;">
                <b>動画面接リンク</b>
                <br>
                <span class="item-title">
                  メールに動画面接のリンクを追記します。
                </span>
                <br>
                <span class="item-title">
                  ※基本設定で動画面接リンクをONにした場合にのみ操作可能です。
                </span>
              </p>
            </div>
            <div class="tab-box-right" style="flex-wrap: wrap;">
              <b-switch
                style="width: 100%;"
                size="is-small"
                v-model="calParameter.video_interview_mail"
                :disabled="!calParameter.reminder_flg || !calParameter.video_interview_memo || scenarioEdit.is_confirm"
              >
                リンクを追記{{calParameter.video_interview_mail ? 'する' : 'しない'}}
              </b-switch>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- リマインダーメール内容 -->
          <div class="tab-box-form">
            <!-- 注釈 -->
            <div class="tab-box-left">
              <p style="text-align: left;">
                <b>メール内容</b>
                <br>
                <span class="item-title">リマインダーメールの内容を設定できます</span>
                <br>
                <span class="item-title">（１）__email__と入力すると訪問者のEmailに沿って変換されます。</span>
                <br>
                <span class="item-title">（２）__applicant__と入力すると訪問者のお名前に沿って変換されます。</span>
                <br>
                <span class="item-title">（３）__point__と入力するとシナリオの設定値に沿って変換されます。</span>
                <br>
                <span class="item-title">（４）__date__と入力すると日程調整した日付をお出しすることができます。</span>
                <br>
                <span class="item-title">（５）FROMに記載がない場合はHRモンスター（noreply@hr-monster.io）からお送りいたします。</span>
              </p>
            </div>
            <!-- タイトル -->
            <div class="tab-box-right" style="flex-wrap: wrap;">
              <p style="width: 100%; text-align: left;font-weight: bold;">件名</p>
              <b-input
                style="width: 100%;"
                placeholder="例：件名を入力"
                v-model="calParameter.reminder_title"
                :disabled="!calParameter.reminder_flg || scenarioEdit.is_confirm"
              />
              <hr>
              <!-- メールアドレス(From) -->
              <p style="width: 100%; text-align: left;font-weight: bold;">FROM</p>
              <b-input
                style="width: 100%;"
                placeholder="例：FROMを入力"
                v-model="calParameter.reminder_from"
                :disabled="!calParameter.reminder_flg || scenarioEdit.is_confirm"
              />
              <hr>
              <!-- メールアドレス(To) -->
              <p style="width: 100%; text-align: left;font-weight: bold;">TO（カンマ区切りで追加できます。）</p>
              <b-input
                style="width: 100%;"
                placeholder="例：TOを入力"
                v-model="calParameter.reminder_to"
                :disabled="!calParameter.reminder_flg || scenarioEdit.is_confirm"
              />
              <hr>
              <!-- メールアドレス(Cc) -->
              <p style="width: 100%; text-align: left;font-weight: bold;">CC（カンマ区切りで追加できます。）</p>
              <b-input
                style="width: 100%;"
                placeholder="例：CCを入力"
                v-model="calParameter.reminder_cc"
                :disabled="!calParameter.reminder_flg || scenarioEdit.is_confirm"
              />
              <hr>
              <!-- メール本文 -->
              <p style="width: 100%; text-align: left; font-weight: bold;">メールの内容を入力してください。</p>
              <div style="width: 100%; height: auto;">
                <quill-editor
                v-model="calParameter.reminder_content"
                ref="quillEditor"
                :options="optionsRemainder"
                :disabled="!calParameter.reminder_flg || scenarioEdit.is_confirm"
              />
              </div>
            </div>
          </div>
        </b-tab-item>
        <!-- リマインダー設定タブ -->
        <b-tab-item label="リマインダー設定（SMS）" class="tab-box disp-scroll">
          <!-- リマインダー通知設定 -->
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p style="text-align: left;">
                <b>リマインダー通知</b>
                <br>
                <span class="item-title">
                  ONにすると設定したSMSが届きます
                </span>
              </p>
            </div>
            <div class="tab-box-right">
              <b-switch style="width: 100%;" v-model="calParameter.reminder_flg_sms" :disabled="scenarioEdit.is_confirm">切替</b-switch>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- リマインダー通知日設定 -->
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p style="text-align: left;">
                <b>リマインダー通知日</b>
                <br>
                <span class="item-title">
                  日程調整をした日の何日前に送るか設定します
                </span>
              </p>
            </div>
            <div class="tab-box-right">
              <p style="display: flex; align-items: center;">
                <b-numberinput
                  v-model="calParameter.reminder_day_sms"
                  :editable="false"
                  min="0"
                  max="10"
                  style="width: 100px;"
                  size="is-small"
                  controls-position="compact"
                  :disabled="!calParameter.reminder_flg_sms || scenarioEdit.is_confirm"
                />
                <span style="margin-left: 4px;">日前</span>
              </p>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- 直前リマインダー通知設定 -->
          <div class="tab-box-form">
            <div class="tab-box-left">
              <p style="text-align: left;">
                <b>直前リマインダー通知</b>
                <br>
                <span class="item-title">
                  ONにすると登録された予定時間の直前に再度SMSが届きます<br/>
                  ※30分〜120分前の間で設定可能です
                </span>
              </p>
            </div>
            <div class="tab-box-right">
              <b-switch
                style="width: 40%;"
                v-model="calParameter.reminder_before_flg_sms"
                :disabled="!calParameter.reminder_flg_sms || scenarioEdit.is_confirm"
              >
                切替
              </b-switch>
              <p style="display: flex; align-items: center;">
                <b-numberinput
                  style="width: 100px;"
                  size="is-small"
                  :editable="false"
                  step="10"
                  min="30"
                  max="120"
                  v-model="calParameter.reminder_before_minute_sms"
                  controls-position="compact"
                  :disabled="!calParameter.reminder_flg_sms||!calParameter.reminder_before_flg_sms || scenarioEdit.is_confirm"
                />
                <span style="margin-left: 4px;">分前</span>
              </p>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- 動画面接リンク挿入設定 -->
          <div class="tab-box-form">
            <div class="tab-box-left" style="flex-wrap: wrap;">
              <p style="text-align: left;">
                <b>動画面接リンク</b>
                <br>
                <span class="item-title">
                  SMSに動画面接のリンクを追記します。
                </span>
                <br>
                <span class="item-title">
                  ※基本設定で動画面接リンクをONにした場合にのみ操作可能です。
                </span>
              </p>
            </div>
            <div class="tab-box-right" style="flex-wrap: wrap;">
              <b-switch
                style="width: 100%;"
                size="is-small"
                v-model="calParameter.video_interview_sms"
                :disabled="!calParameter.reminder_flg_sms || !calParameter.video_interview_memo || scenarioEdit.is_confirm"
              >
                リンクを追記{{calParameter.video_interview_sms ? 'する' : 'しない'}}
              </b-switch>
            </div>
          </div>
          <div class="dot-line"></div>
          <!-- リマインダーSMS内容 -->
          <div class="tab-box-form">
            <!-- 注釈 -->
            <div class="tab-box-left">
              <p style="text-align: left;">
                <b>SMS内容</b>
                <br>
                <span class="item-title">リマインダーSMSの内容を設定できます</span>
                <br>
                <span class="item-title">（１）送付内容は670文字以内（動画面接リンクを追記する場合は550文字以内）でお願いいたします。</span>
                <br>
                <span class="item-title">（２）送信元は入力がない場合はHRmonsterからの送付となります。半角英数字のみ11文字以内でお願いいたします。</span>
                <br>
                <span class="item-title">（３）__applicant__と入力すると訪問者のお名前に沿って変換されます。</span>
                <br>
                <span class="item-title">（４）__point__と入力するとシナリオの設定値に沿って変換されます。</span>
                <br>
                <span class="item-title">（５）__date__と入力すると日程調整した日付をお出しすることができます。</span>
              </p>
            </div>
            <!-- タイトル -->
            <div class="tab-box-right" style="flex-wrap: wrap;">
              <!-- SMS(From) -->
              <p style="width: 100%; text-align: left;font-weight: bold;">FROM</p>
              <b-input
                style="width: 100%;"
                placeholder="例：FROMを入力"
                v-model="calParameter.reminder_from_sms"
                :disabled="!calParameter.reminder_flg_sms || scenarioEdit.is_confirm"
              />
              <hr>
              <!-- SMS(To) -->
              <p style="width: 100%; text-align: left;font-weight: bold;">TO</p>
              <b-input
                style="width: 100%;"
                placeholder="例：TOを入力"
                v-model="calParameter.reminder_to_sms"
                :disabled="!calParameter.reminder_flg_sms || scenarioEdit.is_confirm"
              />
              <hr>
              <!-- SMS本文 -->
              <p style="width: 100%; text-align: left; font-weight: bold;">SMSの内容を入力してください。</p>
              <div style="width: 100%; height: auto;">
                <textarea
                  class="textarea input disp-scroll"
                  maxlength="670"
                  v-model="calParameter.reminder_content_sms"
                  ref="quillEditor"
                  :disabled="!calParameter.reminder_flg_sms || scenarioEdit.is_confirm"
                ></textarea>
              </div>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
    </section>
  </template>
  
  <script>
  import SelectMemberTable from '@/components/molecules/tables/SelectMemberTable'
  
  export default {
    components: {
      /** メンバー一覧 */
      SelectMemberTable,
    },
    props: {
      /** シナリオデータ */
      scheduleParam: {
        type    : Object,
        required: true
      },
      scenarioEdit: {
        type    : Object,
        required: true
      },
      calendarSettings: {
        type    : Array,
        required: true
      },
      /** 自ユーザー */
      user: {
        type    : Object,
        required: true
      },
      /** ユーザー */
      users: {
        type    : Array,
        required: true
      },
      usersStatusAPI: {
        type: Array,
        required: true,
      }
    },
    data () {
      return {
        /** 日程自動調整設定値 */
        calParameter: {},
        /** 開始時間 */
        start: new Date(2000, 1, 1, 9, 0),
        /** 終了時間 */
        end  : new Date(2000, 1, 1, 18, 0),
        /** リマインダーのメール内容オプション */
        optionsRemainder: {
          theme: 'snow',
          placeholder: '内容を入力...',
          modules: {
            toolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'color': [] }, { 'background': [] }]]
          }
        },
        /** 週リスト */
        weekdayList: [
          '月', '火', '水', '木', '金', '土', '日'
        ],
      }
    },
    created () {
      this.initSchedule()
    },
    watch: {
      'calParameter.reminder_flg' () {
        // リマインダーフラグ系制御
        if (!this.calParameter.reminder_flg) {
          this.calParameter.reminder_before_flg = false
          this.calParameter.reminder_member_flg = false
        }
      },
      'calParameter.is_nothing_target_date' () {
        // 希望日程を選択する場合は分岐を追加する
        if (this.calParameter.is_nothing_target_date) {
          if (this.scenarioEdit.select.length == 1) {
            this.$emit('add-select', '')
          }
        } else {
          this.$emit('del-select', 1)
        }
    },
    'calParameter.absoluteMaxDateObj': {
      handler (newVal) {
        this.updateAbsoluteMaxDate(newVal)
      }
    },
    'calParameter.useAbsoluteLimit' (newVal) {
      if (!newVal) {
        this.calParameter.absoluteMaxDate = ''
        this.calParameter.absoluteMaxDateObj = null
      }
      }
    },
    methods: {
      /** 参加者から自分の重複削除 */
      addSelfUserHash (userHash) {
        this.calParameter.user_hash = this.$_.xor(this.calParameter.user_hash, [userHash])
      },
      /** 参加者の重複削除 */
      addUserHash (data) {
        this.calParameter.user_hash = this.$_.xor(this.calParameter.user_hash, [data.user.user_hash])
      },
      /** 任意参加者から自分の重複削除 */
      addSelfUserHashSub (userHash) {
        this.calParameter.user_hash_sub = this.$_.xor(this.calParameter.user_hash_sub, [userHash])
      },
      /** 任意参加者の重複削除 */
      addUserHashSub (data) {
        this.calParameter.user_hash_sub = this.$_.xor(this.calParameter.user_hash_sub, [data.user.user_hash])
      },
      /** 共有者から自分の重複削除 */
      addSelfUserHashShare (userHash) {
        this.calParameter.user_hash_share = this.$_.xor(this.calParameter.user_hash_share, [userHash])
      },
      /** 共有者の重複削除 */
      addUserHashShare (data) {
        this.calParameter.user_hash_share = this.$_.xor(this.calParameter.user_hash_share, [data.user.user_hash])
      },
      initSchedule () {
        // 初期設定
        if (this.scheduleParam.date_method === undefined) {
          // 日程取得方法がなければ初期値追加
          this.$set(this.scheduleParam, 'date_method', 0)
        }
        if (this.scheduleParam.is_private === undefined) {
          // 日程公開設定がなければ初期値追加
          this.$set(this.scheduleParam, 'is_private', false)
        }
        if (this.scheduleParam.user_hash_sub === undefined) {
          // 参加者がなければ初期値追加
          this.$set(this.scheduleParam, 'user_hash_sub', [])
        }
        if (this.scheduleParam.user_hash_share === undefined) {
          // 共有者がなければ初期値追加
          this.$set(this.scheduleParam, 'user_hash_share', [])
        }
        if (this.scheduleParam.reminder_day === undefined) {
          // リマインダー通知日がなければ初期値追加
          this.$set(this.scheduleParam, 'reminder_day', 0)
        }
        if (this.scheduleParam.reminder_before_minute === undefined) {
          // 直前リマインダーがなければ初期値追加
          this.$set(this.scheduleParam, 'reminder_before_minute', 0)
        }
        if (this.scheduleParam.reminder_day_sms === undefined) {
          // リマインダー通知日がなければ初期値追加
          this.$set(this.scheduleParam, 'reminder_day_sms', 0)
        }
        if (this.scheduleParam.reminder_before_minute_sms === undefined) {
          // 直前リマインダーがなければ初期値追加
          this.$set(this.scheduleParam, 'reminder_before_minute_sms', 0)
        }
        if (this.scheduleParam.duplicate_num === undefined) {
          // 仮枠の予定重複許可数
          this.$set(this.scheduleParam, 'duplicate_num', 0)
        }
        if (this.scheduleParam.divide === undefined) {
          // 予定設定間隔設定
          this.$set(this.scheduleParam, 'divide', 30)
        }
        if (this.scheduleParam.period === undefined) {
          // 日程調整期限設定
          this.$set(this.scheduleParam, 'period', 0)
        }
      if (this.scheduleParam.useAbsoluteLimit === undefined) {
        // 絶対日付制限の使用フラグ
        this.$set(this.scheduleParam, 'useAbsoluteLimit', false)
      }
      if (this.scheduleParam.absoluteMaxDate === undefined) {
        // 絶対日付制限の日付
        this.$set(this.scheduleParam, 'absoluteMaxDate', '')
      }
      if (this.scheduleParam.absoluteMaxDateObj === undefined) {
        // 絶対日付制限の日付オブジェクト（UI用）
        this.$set(this.scheduleParam, 'absoluteMaxDateObj', null)
      }
        // 上記以外はそのまま追加
        this.$set(this, 'calParameter', this.scheduleParam)
  
        // 絶対日付制限の文字列をDateオブジェクトに変換
        if (this.calParameter.useAbsoluteLimit && this.calParameter.absoluteMaxDate) {
          try {
            // ISO文字列またはYYYY-MM-DD形式の文字列をDateオブジェクトに変換
            if (typeof this.calParameter.absoluteMaxDate === 'string' && this.calParameter.absoluteMaxDate.trim() !== '') {
              const dateObj = new Date(this.calParameter.absoluteMaxDate)
              if (!isNaN(dateObj.getTime())) {
                this.calParameter.absoluteMaxDateObj = dateObj
              } else {
                this.calParameter.absoluteMaxDateObj = null
              }
            }
          } catch (error) {
            console.warn('日付変換エラー:', error)
            this.calParameter.absoluteMaxDateObj = null
          }
        }
  
        const start_hour   = parseInt(this.calParameter.work_time_start, 10)
        const start_minute = parseInt((this.calParameter.work_time_start * 100) - (start_hour * 100), 10)
        const end_hour     = parseInt(this.calParameter.work_time_end, 10)
        const end_minute   = parseInt((this.calParameter.work_time_end * 100) - (end_hour * 100), 10)
  
        // パラメータの変換
        if (this.calParameter.mtg_time_hour < 0 || this.calParameter.mtg_time_hour > 23) {
          // 予定時間(時)の変換
          this.calParameter.mtg_time_hour = Math.floor(this.calParameter.mtg_time)
        }
        if (this.calParameter.mtg_time_minute < 15 || this.calParameter.mtg_time_minute > 45) {
          // 予定時間(分)の変換
          this.calParameter.mtg_time_minute = parseInt((this.calParameter.mtg_time - Math.floor(this.calParameter.mtg_time)) * 60)
        }
        if (this.calParameter.interval > 0.01 && this.calParameter.interval < 3) {
          // バッファ時間の変換
          this.calParameter.interval = parseInt(this.calParameter.interval * 60)
        }
        // 調整可能時間帯(開始時間)の変換
        this.start = new Date(2017, 0, 15, start_hour, start_minute)
        // 調整可能時間帯(終了時間)の変換
        this.end   = new Date(2017, 0, 15, end_hour, end_minute)
      },
      /** 保存前チェック */
      checkSchedule () {
        const start_hour   = this.start.getHours()
        const start_minute = this.start.getMinutes()
        const end_hour     = this.end.getHours()
        const end_minute   = this.end.getMinutes()
        this.calParameter.work_time_start = parseFloat(start_hour + (start_minute / 100))
        this.calParameter.work_time_end   = parseFloat(end_hour   + (end_minute   / 100))
  
        // タイトルチェック
        if (!this.calParameter.title) {
          alert('タイトルを入力してください')
          return
        } else {
          if (this.calParameter.title.length == 0) {
            alert('タイトルを入力してください')
            this.$emit('setScheduleCheck', false)
            return
          }
        }
        // 面談時間チェック
        if (this.calParameter.mtg_time_hour <= 0 && this.calParameter.mtg_time_minute <= 0) {
          alert('面談時間は0より大きい値を入力してください: 2')
          this.$emit('setScheduleCheck', false)
          return
        }
        if ( this.calParameter.mtg_time_hour > 24 ||
            (this.calParameter.mtg_time_hour === 24 && this.calParameter.mtg_time_minute > 0)
          ) {
          alert('面談時間は24時間以内にしてください')
          this.$emit('setScheduleCheck', false)
          return
        }
        if (this.calParameter.mtg_time_minute > 59) {
          alert('面談時間の分の項目につきましては60分より小さい値を入力してください')
          this.$emit('setScheduleCheck', false)
          return
        }
        // 面談日チェック
        if ((this.end - this.start) <((this.calParameter.mtg_time_hour * 3600 + this.calParameter.mtg_time_minute * 60 + this.calParameter.interval * 2 * 60) * 1000)) {
          alert('調整可能日時は面談時間以上になるように設定してください。\n（バッファの時間×２と面談時間の合計が、調整可能日時を超えていないかの確認もお願いいたします。）')
          this.$emit('setScheduleCheck', false)
          return
        }
        // 間の時間チェック
        if (this.calParameter.interval > 120) {
          alert('バッファにつきましては120分以内になるように設定してください。')
          this.$emit('setScheduleCheck', false)
          return
        }
        if (this.calParameter.interval < 5 && this.calParameter.interval > 0) {
          alert('バッファにつきましては設定する場合、5分以上になるように設定してください。')
          this.$emit('setScheduleCheck', false)
          return
        }
        // 休日チェック
        if (this.calParameter.holiday_list.length > 6) {
          alert('休日が全ての曜日にチェックされております。いずれかの曜日のチェックを外してください。')
          this.$emit('setScheduleCheck', false)
          return
        }
        // ユーザーチェック
        if (this.calParameter.user_hash.length === 0) {
          let isCon = confirm('調整するメンバーを選択していません。\nこのまま保存してもよろしいでしょうか？。')
          if (!isCon) {
            this.$emit('setScheduleCheck', false)
            return
          }
        }
        // 仮枠の場合にはis_ANDをFalseにする
        if (this.calParameter.date_method === 1) {
          this.calParameter.is_AND = false
          this.calParameter.user_hash_sub = []
        }
        // 会社ID
        this.calParameter.company_hash = this.user.companyID
        // 任意参加者と共有者から参加者を削除
        for (const hash of this.calParameter.user_hash) {
          const subHashIdx = this.calParameter.user_hash_sub.indexOf(hash)
          if (subHashIdx >= 0) {
            this.calParameter.user_hash_sub.splice(subHashIdx, 1)
          }
          const shareHashIdx = this.calParameter.user_hash_share.indexOf(hash)
          if (shareHashIdx >= 0) {
            this.calParameter.user_hash_share.splice(shareHashIdx, 1)
          }
        }
        // 共有者から任意参加者を削除
        for (const hash of this.calParameter.user_hash_sub) {
          const shareIdx = this.calParameter.user_hash_share.indexOf(hash)
          if (shareIdx >= 0) {
            this.calParameter.user_hash_share.splice(shareIdx, 1)
          }
        }
        // リマインダーチェック
        if (this.calParameter.reminder_flg) {
          // リマインダー：メールチェック（タイトル）
          if (!this.calParameter.reminder_title) {
            alert('リマインダーメールのタイトルを入力してください')
            this.$emit('setScheduleCheck', false)
            return
          } else {
            if (this.calParameter.reminder_title.length == 0) {
              alert('リマインダーメールのタイトルを入力してください')
              this.$emit('setScheduleCheck', false)
              return
            }
          }
          // リマインダー：メールチェック（To）
          if (!this.calParameter.reminder_to) {
            alert('リマインダーメールの宛先（To）を入力してください')
            this.$emit('setScheduleCheck', false)
            return
          } else {
            if (this.calParameter.reminder_to.length == 0) {
              alert('リマインダーメールの宛先（To）を入力してください')
              this.$emit('setScheduleCheck', false)
              return
            }
          }
          // リマインダー：メールチェック（Content）
          if (!this.calParameter.reminder_content) {
            alert('リマインダーメールの内容を入力してください')
            this.$emit('setScheduleCheck', false)
            return
          } else {
            if (this.calParameter.reminder_content.length == 0) {
              alert('リマインダーメールの内容を入力してください')
              this.$emit('setScheduleCheck', false)
              return
            }
          }
        }
        if (this.calParameter.reminder_flg_sms) {
          // リマインダー：SMSチェック（From）
          if (this.calParameter.reminder_from_sms.length > 11) {
            alert('リマインダーSMSの送信元（From）は11文字以内で入力してください')
            this.$emit('setScheduleCheck', false)
            return
          }
          const reg = new RegExp(/^[0-9a-zA-Z’/ +’ ]*$/)
          if (!reg.test(this.calParameter.reminder_from_sms)) {
            alert('リマインダーSMSの送信元（From）は半角英数字のみで入力してください')
            return false
          }
          // リマインダー：SMSチェック（To）
          if (!this.calParameter.reminder_to_sms) {
            alert('リマインダーSMSの宛先（To）を入力してください')
            this.$emit('setScheduleCheck', false)
            return
          } else {
            if (this.calParameter.reminder_to_sms.length == 0) {
              alert('リマインダーSMSの宛先（To）を入力してください')
              this.$emit('setScheduleCheck', false)
              return
            }
          }
          // リマインダー：SMSチェック（Content）
          if (!this.calParameter.reminder_content_sms) {
            alert('リマインダーSMSの内容を入力してください')
            this.$emit('setScheduleCheck', false)
            return
          } else {
            if (this.calParameter.reminder_content_sms.length == 0) {
              alert('リマインダーSMSの内容を入力してください')
              this.$emit('setScheduleCheck', false)
              return
            }
          }
        }
        if (!this.calParameter.video_interview_memo && !this.calParameter.video_interview_mail) {
          // 動画面接用のURLクリア
          this.calParameter.video_interview_link = ''
        } else {
          // 動画面接用のURL作成
          this.calParameter.video_interview_link = process.env.OWN_ENDPOINT + '/videointerview/' + this.user.companyID + '_' + this.user.userHash + '/rooms'
        }
        // 保存前チェック正常
        this.$emit('setScheduleCheck', true)
        // パラメータを元のパラメータに格納
        this.$emit('setScheduleParameter', this.calParameter)
    },
    /** 絶対日付制限の日付更新 */
    updateAbsoluteMaxDate (date) {
      try {
        // 文字列が渡された場合はDateオブジェクトに変換
        if (typeof date === 'string' && date.trim() !== '') {
          date = new Date(date)
        }
        
        if (date && date instanceof Date && !isNaN(date.getTime())) {
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          
          if (date < today) {
            console.warn('過去の日付が選択されました:', date)
            this.$buefy.toast.open({
              message: '過去の日付は選択できません',
              type: 'is-warning',
              duration: 3000
            })
            this.calParameter.absoluteMaxDateObj = null
            this.calParameter.absoluteMaxDate = ''
            return
          }
          
          const year = date.getFullYear()
          const month = String(date.getMonth() + 1).padStart(2, '0')
          const day = String(date.getDate()).padStart(2, '0')
          this.calParameter.absoluteMaxDate = `${year}-${month}-${day}`
        } else {
          this.calParameter.absoluteMaxDate = ''
        }
      } catch (error) {
        console.error('日付変換エラー:', error)
        this.calParameter.absoluteMaxDate = ''
        this.calParameter.absoluteMaxDateObj = null
      }
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .message {
    background: #ffffff;
    max-height: calc(100vh - 300px);
    padding: 8px;
    .comment {
      text-align: left;
      color: grey;
      font-size: 13px;
    }
  }
  .tab-box {
    background: white;
    border: solid thin #ccc;
    border-radius: 8px;
    height: 350px;
    padding: 16px;
  }
  .tab-box-form {
    width: 100%; display: flex; padding: 8px;
  }
  .tab-box-left {
    width: 40%; display: flex; justify-content: flex-start; align-items: center;
  }
  .tab-box-right {
    width: 60%;
    font-size: 13px;
    padding: 10px;
    justify-content: flex-start;
    display: flex;
    align-items: center;
  }
  .dot-line {
    height: 10px;
    width: 100%;
    background-image: url('../../../../assets/lp/dot.png');
    background-repeat: repeat-x;
    background-size: 10px;
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .item-title {
    color: #666;
    font-size: 12px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/organisms/chatbot/modals/ModalContentSchedule.vue